/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DefinitionDto } from './DefinitionDto';
import {
    instanceOfDefinitionDto,
    DefinitionDtoFromJSON,
    DefinitionDtoFromJSONTyped,
    DefinitionDtoToJSON,
} from './DefinitionDto';

/**
 * @type NumericEvaluationParameterDtoDefinition
 * 
 * @export
 */
export type NumericEvaluationParameterDtoDefinition = DefinitionDto;


export function NumericEvaluationParameterDtoDefinitionFromJSON(json: any): NumericEvaluationParameterDtoDefinition {
    return NumericEvaluationParameterDtoDefinitionFromJSONTyped(json, false);
}

export function NumericEvaluationParameterDtoDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationParameterDtoDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DefinitionDtoFromJSONTyped(json, true) };
    return  DefinitionDtoFromJSONTyped(json, true);
}

export function NumericEvaluationParameterDtoDefinitionToJSON(value?: NumericEvaluationParameterDtoDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDefinitionDto(value)) {
        return DefinitionDtoToJSON(value as DefinitionDto);
    }

    return {};
}

/**
 * Check if a given object implements the NumericEvaluationParameterDtoDefinition interface.
 */
export function instanceOfNumericEvaluationParameterDtoDefinition(value: any): value is NumericEvaluationParameterDtoDefinition {
    if (instanceOfDefinitionDto(value)) return true;
    return false;
}

